export default __webpack_public_path__ + "static/media/img7.74f4d348.png";